import CircularProgress from 'components/circularProgress';
import ConceptSearchBar from 'components/Searchbar/conceptSearchBar';
import Navbar from 'components/navbar';
import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import BulkUpdateModal from 'screens/FDPScreen/components/TargetMarketShare/TargetMarketShareScreen/TargetMarketPlan/components/BulkUpdate';
import { useEffect } from 'react';

const TargetMarketShareHoc = () => {
  const {
    MSPlanStore: { percentProgress, isSalesPlanPercentLoading, toggleBulkUpdateModal, resetStore },
  } = useStore();

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetStore();
    };
  }, [resetStore]);

  return (
    <div>
      <Navbar
        heading="FDP - Sales Plan"
        searchComponent={<ConceptSearchBar />}
        progressComponent={
          <CircularProgress
            value={percentProgress.percentage}
            loading={isSalesPlanPercentLoading}
            toggleFunction={toggleBulkUpdateModal}
          />
        }
      />
      <Outlet />
      <BulkUpdateModal />
    </div>
  );
};

export default observer(TargetMarketShareHoc);
